import { SearchType } from '@/enums/Global';
import {
  Banker,
  LeadsApiOptions,
  SingleLead,
  SingleLeadOverviewResponse,
} from './types';

export type State = {
  loading: boolean;
  leads: SingleLeadOverviewResponse[];
  totalResultCount: number;
  settings: LeadsApiOptions;
  bankers: Array<Banker>;
  bannkersLoading: boolean;
  lead: SingleLead;
  leadLoading: boolean;
  newLeadsCount: number;
  apiOptions: LeadsApiOptions | undefined;
};

export const state: State = {
  loading: false,
  leads: [],
  totalResultCount: 0,
  settings: {
    pageCount: 0,
    pageSize: 0,
    pageStart: 0,
    pageNo: 1,
    sortKey: '',
    sortDesc: true,
    viewDone: false,
    filters: [],
    isManaged: true,
    searchType: SearchType.LEAD,
    searchTerm: '',
  },
  bankers: [],
  bannkersLoading: false,
  lead: {} as SingleLead,
  leadLoading: false,
  newLeadsCount: 0,
  apiOptions: undefined,
};
